
import Button from '@/ui-kit/components/button';
import IconButton from '@/ui-kit/components/icon-button';
import Icon from '@/ui-kit/components/icon';
import { ShapeType } from '@/ui-kit/components/icon-button/enums';
import { ButtonFillType } from '@/ui-kit/components/button/enums';
import StyleClassNamesBuilder from '@/ui-kit/styles/helpers/StyleClassNamesBuilder';
import { StyleColorSchemeType, StyleSizeType } from '@/ui-kit/styles/enums';

export default {
  name: 'ListingAction',
  components: {
    Button,
    IconButton,
    Icon,
  },
  props: {
    action: {
      type: Object,
      required: true,
    },
    size: {
      default: StyleSizeType.Medium,
      type: String,
    },
    fill: {
      default: ButtonFillType.Filled,
      type: String,
    },
    listing: {
      type: Object,
      required: true,
    },
    shapeType: {
      type: String,
      default: ShapeType.Rounded,
    },
    colorScheme: {
      default: StyleColorSchemeType.Secondary,
      type: String,
    },
  },
  data() {
    return {
      isActionInProgress: false,
      StyleSizeType,
    };
  },
  computed: {
    actionClassNames() {
      return new StyleClassNamesBuilder('listing-card-action')
        .addElementClassName(this.action.name)
        .build();
    },
    isActionDisabled() {
      return this.isActionInProgress || this.action.isDisabled;
    },
  },
  methods: {
    async execute() {
      this.$emit('action-button-clicked');
      this.isActionInProgress = true;
      await this.action.execute(this.listing);
      this.isActionInProgress = false;
    },
  },
};
